export const SET_CHATS = '@chats/set';

export const setChats = chats => dispatch => {
  dispatch({
    type: SET_CHATS,
    payload: { chats }
  });
};
